import axios from "axios";
export default {
	methods: {
		setChartData() {
			console.log("Sono nel metodo: setChartData");
			let me = this;
			me.loadDataQuery();
		},
		loadDataQuery() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceData + "/" + me.chartParams.idQuery;
			axios.get(link)
				.then((response) => {
					me.queryResult = response.data.data;
					if (me.queryResult.length > 0) {
						me.configChart.fileds = Object.keys(me.queryResult[0]);
						me.configChart.dimension = me.queryResult.dimension;
						me.configChart.filters = me.queryResult.filters;
						me.configChart.xvalue = me.queryResult.xvalue;
					}
					me.prepareChartData();
				})
				.catch((error) => {
					this.$bvToast.toast("Errore nel salvarei dati: " + error.message, {
						title: "",
						variant: "danger",
						solid: true,
					});
				});
		},
		prepareChartData() {
			let me = this;
			console.log("Prepara Chart Data");
			switch (me.chartParams.graphicType) {
				case "pie":
					console.log("pie");
					me.generaPieGraphic();
					break;
				default:
					console.log("default");
					me.generaDefaultGraphic();
					break;
			}
		},
		generaPieGraphic() {
			let me = this;
			let series = [];
			let xvalues = me.chartParams.xvalue.split(";");
			let xData = [];
			let data = [];
			me.queryResult.forEach((element) => {
				data.push({ value: element[me.chartParams.dimension], name: element[xvalues] });
			});
			let totale = data.reduce((total, element) => total + element.value, 0);
			series = [
				{
					name: me.chartParams.title,
					type: "pie",
					selectedMode: "single",
					radius: [0, "55%"],
					label: {
						position: "center",
						formatter: "{b|{b}}\n{a|{c}}",
						rich: {
							a: {
								color: "#FFF",
								fontSize: 32,
								fontWeight: "bold",
								lineHeight: 30,
							},
							b: {
								color: "#FFF",
								fontSize: 15,
								fontWeight: "bold",
								lineHeight: 45,
							},
						},
					},
					labelLine: {
						show: true,
					},
					data: [{ value: totale, name: "Totale" }],
				},
				{
					name: me.chartParams.title,
					type: "pie",
					radius: ["60%", "80%"],
					label: {
						show: false,
					},
					labelLine: {
						length: 20,
					},
					data: data,
				},
			];
			xData = [...new Set(xData)];
			me.generateChart(xData, series);
		},

		generaDefaultGraphic() {
			let me = this;
			let filter = me.chartParams.filters;
			let series = [];
			let xvalues = me.chartParams.xvalue ? me.chartParams.xvalue.split(";") : [];
			let xData = [];
			let labelsDimesion = [...new Set(me.queryResult.map((rec) => rec[me.chartParams.dimension]))];
			let valoriFiltro = [...new Set(me.queryResult.map((rec) => rec[me.chartParams.filters]))];
			let filtroIniziale = me.chartParams.filtroIniziale;
			let gruppo = me.chartParams.group ? me.chartParams.group : null;
			let categorie = gruppo ? [...new Set(me.queryResult.map((element) => element[gruppo]))] : null;

			for (let label of labelsDimesion) {
				let serie = {
					name: label,
					type: "bar",
					barGap: 0,
					label: label,
					emphasis: {
						focus: "series",
					},
					data: [],
				};
				for (let valoreFiltro of valoriFiltro) {
					for (let xvalue of xvalues) {
						let labelData = valoreFiltro ? xvalue + "-" + valoreFiltro : xvalue;
						if (!filtroIniziale) {
							if (!categorie) {
								xData.push(labelData);
							}
							let records = me.queryResult.filter((rec) => rec[me.chartParams.dimension] === label && rec[filter] == valoreFiltro);
							records.forEach((record) => {
								let value = record[xvalue] > 0 ? record[xvalue] : 0;
								serie.data.push(value);
							});
						} else {
							if (!categorie) {
								xData.push(labelData);
							}
							let records = me.queryResult.filter((rec) => rec[me.chartParams.dimension] === label && rec[filter] == valoreFiltro);
							if (valoreFiltro == filtroIniziale) {
								xData.push(labelData);
								records.forEach((record) => {
									let value = record[xvalue] > 0 ? record[xvalue] : 0;
									serie.data.push(value);
								});
								// let record = me.queryResult.filter((rec) => rec[me.chartParams.dimension] === label && rec[filter] == valoreFiltro);
								// let value = record.length > 0 ? record[0][xvalue] : 0;
								// serie.data.push(value);
							}
						}
					}
				}
				series.push(serie);
			}
			xData = categorie ? categorie : [...new Set(xData)];
			me.generateChart(xData, series);
		},
		generateChart(xData, series) {
			let me = this;
			me.chartData = {
				titolo: "",
				toolbox: {
					show: true,
					orient: "vertical",
					left: "right",
					top: "center",
					feature: {
						mark: { show: true },
						dataView: { show: false, readOnly: false },
						magicType: { show: true, type: ["line", "bar", "stack"] },
						restore: { show: false },
						saveAsImage: { show: true },
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: { show: false },
						axisLabel: {
							show: true,
							interval: 0,
							rotate: 45,
						},
						data: xData,
					},
				],
				series: series,
				unitaMisura: "",
			};
			if (me.chartParams.elementColor) {
				me.chartData.color = me.chartParams.elementColor.split(";");
			}
			me.showOverlay = false;
		},
		onClickViewData() {
			let me = this;
			me.$refs.mdlDataAnalysisModalViewDataComponent.setData(me.queryResult);
			me.$refs.mdlDataAnalysisModalViewDataComponent.show();
		},
		onClickZoomChart() {
			let me = this;
			let chartParams = { title: me.chartParams.title, headerElements: [], bodyElement: me.chartParams, chartData: me.chartData };
			me.$refs.mdlDataAnalysisChartViewModalComponent.setChartParams(chartParams);
			me.$refs.mdlDataAnalysisChartViewModalComponent.show();
		},
		onUpdatePivotParams(pivotParams) {
			this.chartParams.pivotParams = pivotParams;
			this.$emit("updateChart");
		},
		setStaticChartData(chartParams) {
			this.chartParams = chartParams;
			if (this.chartParams.chartData) {
				this.generateStaticChart();
			}
			//
		},
		generateStaticChart() {
			this.chartData = this.chartParams.chartData;
		},
	},
};
